/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarStackedAxis: {
  name: 'bar-stacked-axis';
  data: string;
} = {
  name: 'bar-stacked-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 1 1 1v15h3v-3a1 1 0 1 1 2 0v3h8v-5a1 1 0 1 1 2 0v5a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1Zm15 4a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4-1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V6ZM9 9a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm5 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
